import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { AgmCoreModule } from '@agm/core';
import { HttpModule, Http, RequestOptions } from '@angular/http';
import { AuthHttp, AuthConfig } from 'angular2-jwt';

export function authHttpServiceFactory(http: Http, options: RequestOptions) {
  const headers: Array<Object> = [{
    'Content-Type': 'application/json'
  }];

  const imitateUser = localStorage.getItem('imitateUser');
  if (imitateUser) {
    headers.push({ 'Imitate-User': imitateUser });
  }
  return new AuthHttp(new AuthConfig({
    globalHeaders: headers
  }), http, options);
}

import 'hammerjs';
import './rxjs-extensions';

import { MaterialModule } from './material.module';

import { AppComponent } from './app.component';
import { AuthGuard } from './auth-guard.service';

const routes: Routes = [
  { path: '', loadChildren: 'app/main/main.module#MainModule', canActivate: [AuthGuard] },
  { path: 'login', loadChildren: 'app/login/login.module#LoginModule' }/*,
  { path: 'forgot-password', loadChildren: 'app/forgot-password/forgot-password.module#ForgotPasswordModule' }*/
];

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    RouterModule.forRoot(routes),
    MaterialModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyA4T-q2VBOpGJrvulfHB82hkzjrcWm-2m4',
      libraries: ['places']
    })
  ],
  exports: [],
  providers: [
    AuthGuard, {
      provide: AuthHttp,
      useFactory: authHttpServiceFactory,
      deps: [Http, RequestOptions]
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /builds/pentech-portal/client/src/app/app.module.ts